module.exports = __webpack_public_path__ + "static/media/StudioB.fa4e3966.jpg";